import React from 'react'
import { useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';


const Contacts = () => {
  const [title, setTitle] = useState('')
  const [category, setCategory] = useState('')
  const [utilisateur, setUtilisateur] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')


  const handleSubmit = (e) => {
    e.preventDefault();
     (title==='' || category==='' || utilisateur==='' || email==='' || password==='') ? toast.error("Merci de remplir tous les champ !!!!") : toast.success("Votre inscription à notre s'est déroulée avec succès!");
     setTitle('')
     setCategory('')
     setUtilisateur('')
     setEmail('')
     setPassword('')
  }
  


  return (<>
      <ToastContainer />
    <div className='Contact'>
      <div className='titre'>Vous Pouvez utiliser le forme ci-dessous pour nous contacter</div>
      <form className='formContact' onSubmit={handleSubmit}>
        <div>
          <label htmlFor="nom">Nom</label>
          <input 
             type="text" 
             name='nom' 
             placeholder='Nom'
             id="nom"
             value={title}
             onChange={e => setTitle(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="prenome">Prenome</label>
          <input 
             type="text" 
             name='prenome' 
             placeholder='Prenom'
             id="prenom"
             value={category}
             onChange={e => setCategory(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="utilisateur">Utilisateur</label>
          <input 
             type="text" 
             name='utilisateur' 
             placeholder='Utilisateur'
             value={utilisateur}
             onChange={e => setUtilisateur(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="email">Email</label>
          <input 
             type="email" 
             name='email' 
             placeholder='Email'
             value={email}
             onChange={e => setEmail(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="password">Password</label>
          <input 
             type="password" 
             name='password' 
             placeholder='Mot de passe'
             value={password}
             onChange={e => setPassword(e.target.value)}
          />
        </div>

        <button type='submit' >
          Submit
        </button>
      </form>
    </div>
    </>)
}

export default Contacts